export enum ApplicationStatus {
  APPLIED = 'applied',
  REAPPLIED = 'reapplied',
  WAITING = 'waiting',
  REVIEWED = 'reviewed',
  CONTACTED = 'contacted',
  SET = 'set',
  WITHDRAWN = 'withdrawn',
  CUSTOM = 'custom'
}

export enum StatusColor {
  GREEN = 'green',
  BLUE = 'blue',
  GRAY = 'gray',
  YELLOW = 'yellow',
  BLACK = 'black',
  RED = 'red'
}

export enum ApplicationSource {
  CARCAREERS = 'Carcareers',
  ZIP_RECRUITER = 'ZipRecruiter',
  APPCAST = 'Appcast',
  TALROO = 'Talroo',
  INDEED = 'Indeed',
  LINKEDIN = 'LinkedIn',
  ADZUNA = 'Adzuna',
}